import cn from 'clsx'
import { StyledWrapper } from './style'

const Wrapper = ({ children, className, tag, ...restProps }) => {
  return (
    <StyledWrapper as={tag} className={cn('wrapper', className)} {...restProps}>
      {children}
    </StyledWrapper>
  )
}

export default Wrapper
